import { defineMessages } from "react-intl";

export const scope = "components.QrCard";

export const messages = defineMessages({
  memo: {
    id: `${scope}.memo`,
    defaultMessage: "Memo",
  },

  generatingMemo: {
    id: `${scope}.generatingMemo`,
    defaultMessage: "Generando memo...",
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: "COPIAR",
  },
  yourAddress: {
    id: `${scope}.yourAddress`,
    defaultMessage: "Tu Address de { ticker } - { network }",
  },
});
